<script setup lang="ts">
import { defineProps } from "vue";

defineProps({
    before: {
        type: String,
        required: true,
    },
    after: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div class="bg-white w-full aspect-5/4 @container">
        <div class="p-3 @md:p-4 h-full flex flex-col gap-3 @md:gap-4">
            <div
                class="bg-brand italic font-light font-brand text-2xl p-2 @md:text-3xl @md:p-3"
            >
                <span class="font-black">POSLEDNIK</span> WIR LACKEN DAS
            </div>

            <div class="flex-1 relative">
                <div
                    :style="{ backgroundImage: `url(${before})` }"
                    class="BeforeAfter__before w-[55%] h-full bg-center bg-cover absolute top-0 left-0"
                />
                <div
                    :style="{ backgroundImage: `url(${after})` }"
                    class="BeforeAfter__after w-[55%] h-full bg-center bg-cover absolute top-0 right-0"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.BeforeAfter {
    &__before {
        clip-path: polygon(0% 0%, 100% 0%, 75% 100%, 0% 100%);
    }

    &__after {
        clip-path: polygon(25% 0%, 100% 0%, 100% 100%, 0% 100%);
    }
}
</style>
